/**
 * i18n/index.ts — vue-i18n configuration for admin panel
 *
 * Loads locale messages from JSON files.
 * Default locale: English (en).
 */

import { createI18n } from 'vue-i18n';

import en from './locales/en.json';

export type MessageSchema = typeof en;

export const i18n = createI18n<[MessageSchema], 'en'>({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
    },
});
